import { restoreManager } from "./RestoreManager";

/**
 * Returns true while ANY restore in the manager is actively uploading or
 * restoring. Used to hide the OCR page's upload UI so the restore file
 * doesn't appear inside the unrelated Inspection Insights page.
 */
export function isRestoreInFlight(): boolean {
  return restoreManager.hasActive;
}
